import { render, staticRenderFns } from "./DisplayProfile.vue?vue&type=template&id=75e74d76&scoped=true&"
import script from "./DisplayProfile.vue?vue&type=script&lang=js&"
export * from "./DisplayProfile.vue?vue&type=script&lang=js&"
import style0 from "./DisplayProfile.vue?vue&type=style&index=0&id=75e74d76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e74d76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VAvatar,VCard})
